import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import DepartmentsData from './DepartmentsData';

const MotionLink = motion.create(Link);

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.055,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 28, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.52, ease: [0.22, 1, 0.36, 1] },
  },
};

const hubVariants = {
  hidden: { opacity: 0, y: 24, scale: 0.92 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
  },
};

const DepartmentsSection = () => (
  <section className="dept-section dept-section--premium">
    <div className="dept-premium-bg" aria-hidden="true">
      <div className="dept-premium-orb dept-premium-orb--1"></div>
      <div className="dept-premium-orb dept-premium-orb--2"></div>
      <div className="dept-premium-orb dept-premium-orb--3"></div>
      <div className="dept-premium-particles"></div>
    </div>

    <div className="auto-container">

      {/* Section heading */}
      <div className="sec-title centered">
        <div className="upper-icon"></div>
        <h2>Coordination Team</h2>
      </div>

      {/* Central hub card */}
      <motion.div
        className="dept-hub-wrapper"
        variants={hubVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        <motion.div
          className="dept-hub-card"
          animate={{ y: [0, -9, 0] }}
          transition={{ duration: 5.8, repeat: Infinity, ease: 'easeInOut' }}
        >
          <span className="dept-hub-yk">YK-USA</span>
          <span className="dept-hub-title">COORDINATION<br />TEAM</span>
          <span className="dept-hub-sub">Departments&nbsp;•&nbsp;Leaders&nbsp;•&nbsp;Seva</span>
        </motion.div>
      </motion.div>

      {/* Responsive department card grid */}
      <motion.div
        className="dept-card-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.08 }}
      >
        {DepartmentsData.map((dept, i) => (
          <MotionLink
            key={dept.id}
            to={`/USA/departments/${dept.slug}`}
            className="dept-pcard"
            style={{ '--dept-gradient': dept.gradient }}
            variants={cardVariants}
            whileHover={{ y: -10, scale: 1.045, transition: { duration: 0.22 } }}
            whileTap={{ scale: 0.97 }}
          >
            <div className="dept-pcard__icon">
              <i className={`fas ${dept.icon}`} />
            </div>
            <div className="dept-pcard__name">{dept.name}</div>
            <div className="dept-pcard__coord">{dept.coordinator}</div>
          </MotionLink>
        ))}
      </motion.div>

      {/* CTA */}
      <div className="dept-section__cta">
        <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
          <Link
            to="/USA/departments"
            className="dept-cta-btn"
            style={{ background: 'rgba(255,255,255,0.85)', color: '#5B5FEF', border: '2px solid #5B5FEF', boxShadow: 'none' }}
          >
            <i className="fas fa-th-large"></i>
            View All Departments
          </Link>
          <a
            href="https://portalyk.yugalkunj.org/#/volunteer/register"
            target="_blank"
            rel="noreferrer"
            className="dept-cta-btn"
          >
            Join Our Mission
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>
        <p>Be part of something greater — volunteer with us today</p>
      </div>

    </div>
  </section>
);

export default DepartmentsSection;
